import { FormElement } from "../../../../components/enums";
import {
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../components/types";
import { Url } from "../../../../router/enums";

import { ComponentId } from "./enums";
import { selectFormData } from "./summary.selectors";
import {
  setOCPropertyContactAgreement,
  setOCPropertyCorrectnessAgreement,
} from "./summary.slice";

export const form: FormSchema<SimpleFormSchemaComponents> = {
  selector: selectFormData,
  //JIRA LPPLWEBMOB-721
  //redirect: Url.OC_PROPERTY_SENDING,
  redirect: Url.OC_PROPERTY,
  content: [
    {
      title: "Zgody",
      sections: [
        {
          id: "property-summary-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.CORRECTNESS_AGREEMENT,
              onChange: setOCPropertyCorrectnessAgreement,
              label: "",
              marketingLabel: "zobacz zgody",
              items: [
                {
                  label: "Potwierdzam poprawność wprowadzonych danych",
                  value: "true",
                },
              ],
              required: true,
            },
          ],
        },
        {
          id: "property-summary-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.MARKETING_CHECKBOX,
              id: ComponentId.CONTACT_AGREEMENT,
              onChange: setOCPropertyContactAgreement,
              label: "",
              marketingLabel: "zobacz zgody",
              items: [
                {
                  label: "Wyrażam zgodę na kontakt w celu likwidacji szkody",
                  value: "true",
                },
              ],
              required: true,
            },
          ],
        },
      ],
    },
  ],
};
